import { jsxs as l, jsx as e } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "url(#telegram_colored_svg__a)",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M6.526 11.895a477 477 0 0 1 5.832-2.513c2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.42.42 0 0 1 .142.271c.014.078.03.255.017.394-.15 1.581-.802 5.418-1.133 7.19-.14.749-.416 1-.683 1.025-.581.053-1.022-.384-1.585-.753-.88-.577-1.377-.936-2.231-1.499-.988-.65-.348-1.008.215-1.593.147-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177s-.145-.034-.207-.02q-.132.03-4.218 2.788-.599.411-1.084.4c-.358-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657q.033-.27.743-.552",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ l(
        "linearGradient",
        {
          id: "telegram_colored_svg__a",
          x1: 1002,
          x2: 1002,
          y1: 2,
          y2: 1987.17,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ e("stop", { stopColor: "#2AABEE" }),
            /* @__PURE__ */ e("stop", { offset: 1, stopColor: "#229ED9" })
          ]
        }
      ) })
    ]
  }
);
export {
  r as default
};
